module.exports = __webpack_public_path__ + "static/img/05.1e26837.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour2/05.jpg
// module id = q3Wf
// module chunks = 0